export const toggleClass = function(className, e) {
  e.target.classList.toggle(className);
};

export const animateCSS = function(animationName, e, callback) {
  const node = e.target.element;

  if (e.percentInView === 1 && !node.classList.contains('animation-off')) {
    node.classList.add('animation-off', 'animated', animationName);

    function handleAnimationEnd() {
      node.classList.remove('animated', animationName);
      node.removeEventListener('animationend', handleAnimationEnd);
      if (typeof callback === 'function') callback();
    }

    node.addEventListener('animationend', handleAnimationEnd);
  }
};

export const getParsedQueryFromUrl = $route => {
  const query = $route.query;
  let parsedQuery = '';

  for (let key in query) {
    if (query.hasOwnProperty(key) && query[key] !== '') {
      parsedQuery += `${key}=${query[key]}&`;
    }
  }

  return parsedQuery;
};

export const delay = (function() {
  var timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
